/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'telemetry-config';
const prefix = `${moduleName}.${componentName}`;

export const telemetryCheckboxInputLabel = `${prefix}.telemetryCheckboxInputLabel`;
export const telemetryUrlPlaceholder = `${prefix}.telemetryUrlPlaceholder`;
export const customerProgramLabel = `${prefix}.customerProgramLabel`;

export const ENGLISH = {
    [telemetryCheckboxInputLabel]: 'Enable \'Share Telemetry Data\'',
    [telemetryUrlPlaceholder]: 'Enter Telemetry Url',
    [customerProgramLabel]: 'Customer Program',
};
